/* eslint-disable react-hooks/exhaustive-deps */
import { InputText } from "primereact/inputtext";
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { DataTable, DataTableFilterMeta, DataTableSelectionSingleChangeEvent } from "primereact/datatable";
import { Column, ColumnEditorOptions } from "primereact/column";
import { useEffect, useMemo, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Toast } from "primereact/toast";
import { classNames } from 'primereact/utils';
import { Panel } from "primereact/panel";
import { Button } from "primereact/button";
import React from "react";
import { Dialog } from "primereact/dialog";
import { Link } from "react-router-dom";
import Fabric from "../../models/Fabric";
import { useMsal } from "@azure/msal-react";
import MaintenanceService from "../../service/MaintenanceService";
import { Dropdown } from "primereact/dropdown";
import autoTable from "jspdf-autotable";
import { FilterMatchMode, FilterOperator } from "primereact/api";

interface DropdownItem {
    name: string;
    code: string;
}

const defaultFilters: DataTableFilterMeta = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    fabricCd: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    description: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    status: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    processed: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    updTs: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    updUser: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    }
};

export default function FabricView() {
    let empty: Fabric = {
        fabricCd: '',
        fabricDesc: '',
        fabricStatus: '',
        fabricProcessed: '',
        fabricUpdUser: '',
        fabricUpdTs: ''
    };

    const status: DropdownItem[] = useMemo(
        () => [
            { name: 'Active', code: 'A' },
            { name: 'Deleted', code: 'D' }
        ],
        []
    );

    const processed: DropdownItem[] = useMemo(
        () => [
            { name: 'Yes', code: 'Y' },
            { name: 'No', code: 'N' }
        ],
        []
    );

    const [listValues, setListValues] = useState<Fabric[]>([]);
    const [listFilteredData, setListFilteredData] = useState<Fabric[]>([]);
    const [updateTrigger, setUpdateTrigger] = useState(0);
    const [singleValue, setSingleValue] = useState<Fabric>(empty);
    const [loading, setLoading] = useState(true);
    const [globalFilter, setGlobalFilter] = useState<string>('');
    const isNew = useRef(false);
    const form = useForm();
    const formEdit = useForm({ mode: "onChange" });
    const [editingRows, setEditingRows] = useState({});
    const errors = form.formState.errors;
    const toast = useRef<any>(null);
    const [deleteDialog, setDeleteDialog] = useState(false);
    const { accounts } = useMsal();
    const dt = useRef<any>(null);

    useEffect(() => {
        MaintenanceService.getFabrics().then(data => {
            setListValues(data);
            setLoading(false);
        });

        initFilters();
    }, []);

    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);
    const initFilters = () => {
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = null;
        setFilters(defaultFilters);
        setGlobalFilter('');
    };

    useEffect(() => {
        MaintenanceService.getFabrics().then(data => {
            setListValues(data);
            setLoading(false);
        });
    }, [updateTrigger]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilter(value);
    };

    const getFilteredData = () => {
        const data = listFilteredData.length > 0 ? listFilteredData : dt.current.props.value;

        const bodyData = data.map((item: Fabric) => [
            item.fabricCd,
            item.fabricDesc,
            item.fabricStatus,
            item.fabricProcessed,
            item.fabricUpdUser,
            item.fabricUpdTs
        ]);

        return bodyData;
    };

    const exportPdf = () => {
        const bodyData = getFilteredData();
        import('jspdf').then((jsPDF) => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default("l");
                autoTable(doc, { head: [['Code', 'Description', 'Status', 'Processed', 'Update User', 'Update Date']], body: bodyData })
                doc.save('fabrics.pdf');
            });
        });
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <div>
                <i className="pi pi-file-excel ml-3 text-green-500 cursor-pointer" title="Export CSV" onClick={(e) => { exportCSV(); e.stopPropagation(); }} />
                <i className="pi pi-file-pdf ml-3 text-red-500 cursor-pointer" title="Export PDF" onClick={(e) => { exportPdf(); e.stopPropagation(); }} />
            </div>
            <IconField iconPosition="left">
                <InputIcon className="pi pi-search" />
                <InputText className="p-inputtext-sm" type="search" autoComplete="off" value={globalFilter} onChange={onGlobalFilterChange} placeholder="Search..." />
            </IconField>
        </div>
    );

    const fabricCdTemplate = (rowData: Fabric) => {
        return rowData.fabricCd;
    }

    const descriptionTemplate = (rowData: Fabric) => {
        return rowData.fabricDesc;
    }

    const statusTemplate = (rowData: Fabric) => {
        return rowData.fabricStatus;
    }

    const processedTemplate = (rowData: Fabric) => {
        return rowData.fabricProcessed;
    }

    const updUserTemplate = (rowData: Fabric) => {
        return rowData.fabricUpdUser;
    }

    const updTsTemplate = (rowData: Fabric) => {
        return rowData.fabricUpdTs;
    }

    const clearNew = () => {
        form.reset();
    }

    const getErrorMessage = (name: string) => {
        return errors[name] ? <small className="p-error">{(errors[name] as any).message}</small> : <small className="p-error">&nbsp;</small>;
    };

    const onSubmit = (data: any) => {
        isNew.current = true;
        let _value = { ...singleValue };
        _value.fabricCd = data.fabricCd;
        _value.fabricDesc = data.fabricDesc;
        _value.fabricStatus = data.fabricStatus;
        _value.fabricProcessed = data.fabricProcessed;

        if (accounts[0]) {
            _value.fabricUpdTs = new Date().toISOString();
            _value.fabricUpdUser = accounts[0].username.split('@')[0];
        }

        save(_value);
        form.reset();
    };

    const save = (value: Fabric) => {
        MaintenanceService.addFabric(value).then(() => {
            setUpdateTrigger(prev => prev + 1);
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Fabric Created', life: 3000 });
            setSingleValue(empty);
        }).catch(() => {
            toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Create Fabric', life: 3000 });
        });
    }

    const update = (value: Fabric, oldId: string) => {
        MaintenanceService.updateFabric(value, oldId).then(() => {
            setUpdateTrigger(prev => prev + 1);
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Fabric Updated', life: 3000 });
            setSingleValue(empty);
        }).catch(() => {
            toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Update Fabric', life: 3000 });
        });
    }

    const setActiveRowIndexCE = (rowData: DataTableSelectionSingleChangeEvent<Fabric[]>) => {
        let selectedIndex = listValues.findIndex(v => v.fabricCd === (rowData.value as Fabric).fabricCd);
        let _editingRows = { ...editingRows, ...{ [`${listValues[selectedIndex].fabricCd}`]: true } };
        if (Object.keys(_editingRows).length === 1) {
            setEditingRows(_editingRows);
        }
    }

    const onRowEditChange = (e: any) => {
        setEditingRows(e.data);
    }

    const onRowEditComplete = (e: any) => {
        let _listValues = [...listValues];
        let { newData } = e;
        let index = listValues.findIndex(v => v.fabricCd === newData.fabricCd);
        _listValues[index] = newData;

        setListValues(_listValues);
    }

    const cellEditor = (options: ColumnEditorOptions) => {
        switch (options.field) {
            case 'fabricCd':
                return codeEditor(options);

            case 'fabricDesc':
                return descriptionEditor(options);

            case 'fabricStatus':
                return statusEditor(options);

            case 'fabricProcessed':
                return processedEditor(options);
        }
    }

    const codeEditor = (options: any) => {
        return (
            <Controller
                name="fabricCdEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Code is required.',
                    validate: {
                        unique: v => listValues.filter(val => val.fabricCd.toLowerCase() === v.toLowerCase()).length === 0 || 'Code must be unique.'
                    }
                }}
                render={({ field, fieldState }) => {
                    singleValue.fabricCd = field.value;
                    return (
                        <>
                            <InputText ref={field.ref} value={fieldState.isDirty ? field.value : options.value} maxLength={3} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { singleValue.fabricCd = e.target.value; field.onChange(e.target.value.toUpperCase()); }} placeholder="Code" />
                        </>
                    )
                }
                }
            />
        );
    }

    const descriptionEditor = (options: any) => {
        return (
            <Controller
                name="fabricDescEdit"
                control={formEdit.control}
                defaultValue={options.value}
                render={({ field, fieldState }) => {
                    singleValue.fabricDesc = field.value;
                    return (
                        <>
                            <InputText ref={field.ref} value={fieldState.isDirty ? field.value : options.value} maxLength={25} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { singleValue.fabricDesc = e.target.value; field.onChange(e.target.value.toUpperCase()); }} placeholder="Description" />
                        </>
                    )
                }
                }
            />
        );
    }

    const statusEditor = (options: any) => {
        return (
            <Controller
                name="fabricStatusEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Status is required.'
                }}
                render={({ field, fieldState }) => {
                    singleValue.fabricStatus = field.value;
                    return (
                        <>
                            <Dropdown ref={field.ref} inputId={field.name} value={fieldState.isDirty ? field.value : options.value} options={status} optionLabel="name" optionValue="code" tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => { singleValue.fabricStatus = e.target.value; field.onChange(e.value) }} placeholder="Select..." />
                        </>
                    )
                }
                }
            />
        );
    }

    const processedEditor = (options: any) => {
        return (
            <Controller
                name="fabricProcessedEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Processed is required.'
                }}
                render={({ field, fieldState }) => {
                    singleValue.fabricProcessed = field.value;
                    return (
                        <>
                            <Dropdown ref={field.ref} inputId={field.name} value={fieldState.isDirty ? field.value : options.value} options={processed} optionLabel="name" optionValue="code" tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => { singleValue.fabricProcessed = e.target.value; field.onChange(e.value) }} placeholder="Select..." />
                        </>
                    )
                }
                }
            />
        );
    }

    const rowEditorTemplate = (rowData: Fabric, props: any) => {
        const rowEditor = props.rowEditor;
        if (rowEditor.editing) {
            isNew.current = false;

            return (
                <>
                    <Button icon="p-row-editor-save-icon pi pi-fw pi-save" title="Save" rounded text severity="info" type="submit" onClick={(e) => {
                        if (!formEdit.getFieldState("fabricCdEdit").invalid && !formEdit.getFieldState("fabricDescEdit").invalid) {
                            let _singleValue = { ...singleValue };
                            let oldId = rowData.fabricCd;

                            if (accounts[0]) {
                                _singleValue.fabricUpdTs = new Date().toISOString();
                                _singleValue.fabricUpdUser = accounts[0].username.split('@')[0];
                            }

                            update(_singleValue, oldId);
                            formEdit.reset();
                            rowEditor.onSaveClick(e);
                        }
                    }} />

                    <Button icon="p-row-editor-cancel-icon pi pi-fw pi-undo" title="Undo" rounded text severity="danger" onClick={(e) => {
                        formEdit.clearErrors();
                        formEdit.reset();
                        rowEditor.onCancelClick(e);
                    }} />
                </>
            );
        } else {
            return (
                <Link className="pi pi-fw pi-trash rowDelete" title="Delete" onClick={() => confirmDelete(rowData)} to={''}></Link>
            );
        }
    }

    const hideDeleteDialog = () => {
        setDeleteDialog(false);
    };

    const confirmDelete = (value: Fabric) => {
        setSingleValue(value);
        setDeleteDialog(true);
    }

    const deleteRow = () => {
        MaintenanceService.deleteFabric(singleValue.fabricCd).then((data: boolean) => {
            setUpdateTrigger(prev => prev + 1);
            setDeleteDialog(false);
            setSingleValue(empty);
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Deleted', life: 3000 });
        }).catch(() => {
            toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to remove', life: 3000 });
        });

    };

    const deleteDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteRow} />
        </React.Fragment>
    );

    return (
        <>
            <Toast ref={toast} />

            <Panel header="Add Fabric" className="addPanel mb-2 -ml-2">
                <form onSubmit={form.handleSubmit(onSubmit)} className="p-fluid" autoComplete="off">
                    <div className="formgrid grid">
                        <div className="field col-2">
                            <Controller
                                name="fabricCd"
                                control={form.control}
                                defaultValue=""
                                rules={{
                                    required: 'Code is required.',
                                    validate: {
                                        unique: v => listValues.filter(val => val.fabricCd.toLowerCase() === v.toLowerCase()).length === 0 || 'Code must be unique.'
                                    }
                                }}
                                render={({ field, fieldState }) => (

                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Code</label>
                                        <InputText id={field.name} name={field.name} value={field.value} maxLength={3} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { field.onChange(e.target.value.toUpperCase()); }} placeholder="Code" />
                                        {(field.value !== null && field.value !== undefined) ? <small className="text-primary">{field.value}</small> : <></>}
                                        {getErrorMessage('fabricCd')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="fabricDesc"
                                control={form.control}
                                defaultValue=""
                                rules={{
                                    required: 'Description is required.'
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Description</label>
                                        <InputText id={field.name} name={field.name} value={field.value} maxLength={25} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => field.onChange(e.target.value.toUpperCase())} placeholder="Description" />
                                        {(field.value !== null && field.value !== undefined) ? <small className="text-primary">{field.value}</small> : <></>}
                                        {getErrorMessage('fabricDesc')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="fabricStatus"
                                control={form.control}
                                defaultValue={'A'}
                                rules={{
                                    required: 'Status is required.'
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Status</label>
                                        <Dropdown inputId={field.name} value={field.value} options={status} optionLabel="name" optionValue="code" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                            onChange={(e) => { field.onChange(e.value) }} placeholder="Select..." />
                                        {getErrorMessage('fabricStatus')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="fabricProcessed"
                                control={form.control}
                                defaultValue={'N'}
                                rules={{
                                    required: 'Processed is required.'
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Processed</label>
                                        <Dropdown inputId={field.name} value={field.value} options={processed} optionLabel="name" optionValue="code" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                            onChange={(e) => { field.onChange(e.value) }} placeholder="Select..." />
                                        {getErrorMessage('fabricProcessed')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field field-buttons col-2 pt-4">
                            <Button icon="pi pi-save" title="Save" rounded text severity="info" type="submit" />
                            <Button icon="pi pi-undo" title="Undo" rounded text severity="danger" type="button" onClick={clearNew} />
                        </div>
                    </div>
                </form>
            </Panel>

            <DataTable ref={dt} className="-ml-2" value={listValues} selectionMode="single" onSelectionChange={setActiveRowIndexCE}
                dataKey="fabricCd" size="small" rowHover={true} loading={loading}
                scrollable scrollHeight="calc(100vh - 23.9rem)"
                paginator rows={25} rowsPerPageOptions={[5, 10, 25]} alwaysShowPaginator={false}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                editingRows={editingRows} editMode="row" onRowEditChange={onRowEditChange} onRowEditComplete={onRowEditComplete}
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
                filters={filters} onValueChange={filteredData => setListFilteredData(filteredData)}
                emptyMessage="No fabric records found." header={header}>
                <Column field="fabricCd" header="Code" sortable body={fabricCdTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="fabricDesc" header="Description" sortable body={descriptionTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="fabricStatus" header="Status" sortable body={statusTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="fabricProcessed" header="Processed" sortable body={processedTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="fabricUpdUser" header="Update User" sortable body={updUserTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="fabricUpdTs" header="Timestamp" sortable body={updTsTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '15%', minWidth: '15rem' }}></Column>
                <Column rowEditor body={rowEditorTemplate} headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
            </DataTable>

            <Dialog visible={deleteDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirm" modal footer={deleteDialogFooter} onHide={hideDeleteDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {singleValue && (
                        <span>
                            Are you sure you want to delete <b>{singleValue.fabricCd}</b>?
                        </span>
                    )}
                </div>
            </Dialog>
        </>
    )
}
